import React, { useEffect, useState } from 'react';
import "./ContactFavContact.css";
import { useUser } from '../../../../../../context/UserContext';
import { markContactfavByUser } from '../../../../../../services/iqApiV2';
import IOSSpinner from '../../../../../HtmlElements/IOSSpinner';


function ContactFavContact({ favoritted, opportunityId, contactId }) {
  const { user } = useUser();
  const [isFavourite, setIsFavourite] = useState(favoritted ?? false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (favoritted !== undefined) {
      setIsFavourite(favoritted);
    }
  }, [favoritted]);

  const toggleFavourite = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (!user?.id || !contactId || !opportunityId) return;

    try {
      setLoading(true);
      const response = await markContactfavByUser(user.id, contactId, opportunityId);

      if (response !== undefined) {
        console.log("response",response)
        setIsFavourite(response);
      }
    } catch (err) {
      console.error("Error toggling favorite:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cfc-fav-wrapper" onClick={toggleFavourite}>
      <span className={`cfc-star-icon ${isFavourite ? 'cfc-filled' : ''}`}>
        {loading ?  <IOSSpinner/>: isFavourite ? '★' : '☆'}
      </span>
    </div>
  );
}

export default ContactFavContact;
